<template lang="html">

  <section class="ruta-cervatina row-center ais banner-child-vive animation" :id="$t('banners_experiencia.ruta_cervantina.id')">
    
    <div class="imagen">
      <article class="banner-ruta-cervatina row-center plum-border -brown -xl">
        <router-link :to="$t('enlaces.ruta_cervantina')" class="enlace-cover"></router-link>
        <router-link :to="$t('enlaces.ruta_cervantina')" class="btn">
          <span v-html="$t('banners_experiencia.ruta_cervantina.boton')"></span>
        </router-link>
      </article>
    </div>

    <div class="texto column-center">
      <div class="container -half">
        <h2 class="title" v-html="$t('banners_experiencia.ruta_cervantina.titulo')"></h2>
        <p v-html="$t('banners_experiencia.ruta_cervantina.cuerpo')"></p>
      </div>
    </div>


  </section>

</template>

<script lang="js">
 export default  {
  name: 'banner-ruta-cervantina',
}
</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";

.ruta-cervatina{
  width: 100%;
  background: $mud-brown;
}

p{
  text-align: justify;
}

.texto{
  background: $mud-brown;
}

.ruta-cervatina > div{
  width: 50%;
}

  @media screen and (max-width: 1023px){
  .ruta-cervatina > div{
  width: 100%;
  height: auto;
  padding: 50px 25px;
  &.texto{
    padding: 50px 0 0 0;
    order: -1;
  }
}
}


</style>



// WEBPACK FOOTER //
// src/components/parts/banner-ruta-cervantina.vue